<template>
	<div class="excel-file">
		<template v-if="initState">
			<input
				type="file"
				id="fileInput123"
				ref="excelInput123"
				@change="onChange"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
			/>
		</template>
		<div class="excel-file__input d-flex w-100">
			<div class="excel-file__input__info__left pl-3 d-flex">
				<label for="fileInput123" class="excel-file__input__label input-icon m-0 py-3 px-2">
					<i class="icon-sf-upload" />
					<div class="excel-file__input__label__msg">{{ getMessage_('QWCC000927') }}</div>
				</label>
			</div>
			<div class="excel-file__input__info__right pl-3 d-flex">
				<div class="excel-file__input__info__msg">
					<span>{{ fileNames }}</span>
					<i class="icon-sf-circle-close qms-close" @click="deleteFile" v-show="!$sf_isEmptyObj(file)" />
				</div>
			</div>
			<div class="excel-file__input__progress"></div>
		</div>
		<div class="excel-file__error">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th>Error Message</th>
						</tr>
						<tr>
							<td><textarea class="excel-file__error__text addScroll" style="height: 380px; width: 860px" v-model="errMsg" readonly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: ['initState', 'propError'],
	data() {
		return {
			file: {},
			errMsg: ''
		};
	},
	computed: {
		...rootComputed,
		fileNames() {
			const defaultMsg = this.getMessage_('QWCC001973'); // 파일을 첨부해주세요.
			return this.$sf_isEmptyObj(this.file) ? defaultMsg : this.file.name;
		}
	},
	watch: {
		file() {
			this.$emit('uploadExcel', this.file);
		},
		initState() {
			this.$refs.excelInput123.value = '';
			this.file = {};
			this.errMsg = '';
		},
		propError(newVal, oldVal) {
			this.errMsg = newVal;
		}
	},
	methods: {
		...rootMethods,
		onChange({ target: { files } }) {
			this.file = files[0];
			this.errMsg = '';
		},
		deleteFile() {
			this.file = {};
			this.errMsg = '';
			this.$refs.excelInput123.value = '';
		}
	}
};
</script>

<style lang="scss" scoped>
.excel-file {
	&__input {
		flex-direction: row;
		align-items: center;
		&__label {
			width: 100% !important;
			&__msg {
				font-size: 15px;
				font-weight: bold;
			}
		}
		&__info {
			flex-direction: column;
			justify-content: center;
			height: 30px;
			&__left {
				width: 15%;
			}
			&__right {
				width: 85%;
			}
		}
	}
	&__error {
		width: 98%;
		margin-top: 30px;
		height: 250px;
		&__text {
			padding: 10px;
		}
	}
	input[type='file'] {
		display: none !important;
	}
	.qms-close {
		margin: 0 8px;
		font-size: 5px;
		color: var(--color-error);
		cursor: pointer;

		&:hover {
			font-size: 12px;
		}
	}
}
.sf-button {
	width: fit-content;
}
</style>
